module.exports = __webpack_public_path__ + "static/img/n_03.490404f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/jiameng/n_03.jpg
// module id = P4r5
// module chunks = 0